import React, {useEffect, useMemo, useRef, useState} from 'react'
import {useGLTF, useTexture} from '@react-three/drei'
import * as THREE from "three";

function TextureMaterial({material, size, rotation}) {
    const colorMap = useTexture(material.colorMap);
    colorMap.flipY = false;                                                 // all need the flipY = false
    const clone = useMemo(() => colorMap.clone(), [colorMap]);
    //clone.rotation = Math.abs(rotation.z);
    clone.repeat.x = size[0] / material.width;
    clone.repeat.y = size[1] / material.height;
    clone.wrapS = THREE.RepeatWrapping;
    clone.wrapT = THREE.RepeatWrapping;

    return <meshStandardMaterial map={clone} />
}

function Wall({geometry, position, rotation, scale, castShadow, receiveShadow, material, details}) {
    const wall = useRef();
    //console.log(props)

    // Material
    let materialProps = {}
    if(material.type == 'color') {
        materialProps = {
            color : material.color
        }
    } else {
        if (details.active_product == null) {
            materialProps = {
                transparent: true,
                opacity: 0
            }
        }
    }

    return <mesh
        ref={wall}
        receiveShadow={receiveShadow}
        geometry={geometry}
        position={position}
        rotation={rotation}
        scale={scale}
    >
        {
            material.type == 'texture' ? <TextureMaterial material={material} size={details.size} rotation={rotation} /> : <meshStandardMaterial {...materialProps} />
        }
    </mesh>
}

export default function Walls({model, details, updateWalls, _handleLoadingError}) {

    // find position coordinates for the Walls Model
    // const plane = useRef();
    // Load Model
    const { nodes } = useGLTF(model.url);

    const walls = useMemo(() => {
        // Create walls dynamically
        let temp = [];
        let count = 0;

        const sortObject = Object.keys(nodes).sort().reduce(function (result, key) {
            result[key] = nodes[key];
            return result;
        }, {});

        Object.keys(sortObject).forEach(key => {
            const wallId = parseInt(key.split("Wall")[1])-1;
            if(key.search("Wall") > -1) {
                let value = nodes[key];
                value.wallDetails = details[count];
                //console.log(details[count])
                // set material data
                let hasMaterial = false;
                if(details[count] === undefined) {
                    _handleLoadingError('Wall part missing');
                } else {
                    if(details[count].activeProduct != undefined) {
                        value.material = details[count].activeProduct.material;
                        hasMaterial = true;
                    }
                }
                if(!hasMaterial) {
                    value.material = { type: 'none' };
                }
                temp.push(value);
                count++;
            }
        });
        const walls = temp.map((node, i) =>
            (<Wall
                key={i}
                castShadow
                receiveShadow
                geometry={node.geometry}
                position={node.position}
                rotation={node.rotation}
                scale={node.scale}
                material={node.material}
                details={node.wallDetails}
            />)
        )
        return walls;
    }, [nodes, updateWalls]);

    return (
        <group
            // ref={plane}
            position={model.position}
            scale={model.scale}
            rotation={model.rotation}
            dispose={null}
        >
            {walls}
        </group>
    )
}
